<template>
	<div>
		<PageHeaderLayout>
			<el-button type="" style="margin-bottom: 10px;" @click="goBack()"  icon="el-icon-back" size="medium">
				返回
			</el-button>
			<div class="main-page-content"
				v-loading="loadingStaus"
				:element-loading-text="loadingText">
				<el-row :gutter="48">
					<el-form ref="companyForm" :model="formData" :rules="rules" label-width="100px">
						<el-col :span="18">
							<el-form-item label="公司名称" prop="company_name">
								<el-input v-model="company_name"></el-input>
							</el-form-item>
							<el-form-item label="企业项目手机号" prop="phone">
								<el-input type="input" v-model="contact_phone"></el-input>
							</el-form-item>
							<el-form-item label="项目类型" prop="categorys_text">
								<el-input type="input" v-model="formData.categorys_text"></el-input>
							</el-form-item>
							<el-form-item label="项目需求名称" prop="number">
								<el-input type="input" v-model="formData.title"></el-input>
							</el-form-item>
							<el-form-item label="项目需求描述详情" prop="content">
								<el-input type="textarea" rows="8" v-model="formData.content"></el-input>
							</el-form-item>
							<el-form-item label="项目服务地区" prop="address">
								<el-input type="input" v-model="formData.address"></el-input>
							</el-form-item>
							<el-form-item label="项目服务周期" prop="address">
								<el-input type="input" v-model="formData.bet_time"></el-input>
							</el-form-item>
							<el-form-item label="其他服务要求" prop="address">
								<el-input type="textarea" rows="6" v-model="formData.requirement"></el-input>
							</el-form-item>
							<el-form-item label="性别要求" prop="address">
								<el-input type="input" v-model="formData.sex_text"></el-input>
							</el-form-item>
							<!-- <el-form-item label="年龄要求" prop="address">
								<el-input type="input" v-model="formData.address"></el-input>
							</el-form-item> -->
							<el-form-item label="结算服务费规则" prop="address">
								<el-input type="input" v-model="formData.rules"></el-input>
							</el-form-item>
						</el-col>
					</el-form>
				</el-row>
				<!-- 预览图片弹框 -->
				<el-dialog 
					:title="'预览图片'"
					:visible.sync="dialogVisible" 
					:modal="false"
					:width="'25%'"
				>
					<div class="block" v-if="dialogVisible">
						<img :src="this.imageUrl" class="preview">
					</div>
				</el-dialog>
			</div>
		</PageHeaderLayout>
	</div >
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import UploadFile from "@/components/UploadFile";
import { mapGetters } from 'vuex'

export default {
	components: {
		PageHeaderLayout,
		UploadFile,
	},
	data() {
		return {
			dialogVisible: false,
			activeTab: '0',
			hearTitle: '基本设置',
			loadingStaus: true,
			loadingText: '正在提交中……',
			formDisabled: false,
			billId:0, // 公司id，0表示创建，非零为编辑
			// element的cascader的props值
			cascaderProps:{
				label:'display_name',
				value:'id',
			},
			// 分类列表
			categoryList:[],
			openapiList:[],
			// 标签
			categoryLabelList:[],
			// 已选中的分类列表，用于cascader组件选中效果
			selectedList:[],
			// 已选中标签
			selectedLabelList:[],
			// 公司基本信息表单结构
			formData:{},
			// 已上传图片列表
			uploadFileList:[],
			// 公司基本信息规则
			rules: {
				name: [
					{required: true, message: '输入公司名称', trigger: 'blur' },
				],
				file_url: [
					{required: true, message: '输入文件名称', trigger: 'blur' },
				]
			},
			// 附件类型
			attachmentType:['application/pdf','application/caj','','application/zip','application/rar','application/doc'],
			// 已上传附件列表
			attachmentUploadFileList:[],
			imageUrl: '',//图片地址
			is_ysy:false,
			project_id:this.$route.query.project_id,
			ph_user_id:this.$route.query.id,
			company_name:this.$route.query.company_name,
			contact_phone:this.$route.query.contact_phone,
			company_status:this.$route.query.company_status,
		}
	},
	computed: {
		...mapGetters(['userPermissions']),
	},
	methods: {
		/* 预览图片 */
		showImage(data) {
			this.dialogVisible = true;
			this.imageUrl = data;
		},
		// 初始化公司基本信息
		async init() {
			if (this.project_id) {
				let info = await this.$api.viewPaihuoProject(this.project_id)
				info['fw_address'] = (info.province+info.city+info.area+info.province+info.address)??'';
				info['bet_time'] = (info.start_date+'至'+info.end_date)??'';
				info['sex_text'] = info.sex==1?'女':info.sex==2?'男':'不限';
				info['rules'] = (info.free+'/'+info.unit)??'';
				info['categorys_text'] = "";
				info.categorys.forEach(function(item){
					if(info['categorys_text']=="") {
						info['categorys_text'] = item.display_name;
					} else {
						info['categorys_text'] = info['categorys_text']+";"+item.display_name;
					}
				})
				this.formData = info
			}
		},
		//返回上一页
		goBack() {
			this.$router.push({ path: "/paihuo/paihuo_project" ,query:{id:this.ph_user_id,company_name:this.company_name,contact_phone:this.contact_phone,status:this.company_status}});
		}
	},
	async mounted() {
		this.loadingStaus = true
		this.init()
		this.$nextTick(() => {
			this.loadingStaus = false
		})
		if(this.$config.domain.ename === 'opryousuiyun') {
			this.is_ysy = true;
		}
	},
}
</script>

<style lang="stylus" scoped>
  .content-left
    min-height 640px
    border-right 1px solid  #e8e8e8
    .el-cascader
      display block
      width 320px
  .back-btn
    position absolute;
    right 50px;
    top 150px;
  .content-right
    .right-button
      border-top 1px solid #e8e8e8e8
      padding 12px 12px
    .el-form-item__label
      float none
      display inline-block
      text-align left
      padding 0 0 10px 0
    .el-form-item__content
      margin-left 0px !important
      .el-checkbox-group
        margin-top -12px
  .preview
    width: 100%	
  .idImg
    width: 100px
    cursor: pointer
</style>
